import { useMutation } from "react-query";
import { ParametrosAreaComum } from "../typings";
import http from "infra/http";

function useSaveParametrosAreaComum(tenantId: string) {
  return useMutation(
    (data: ParametrosAreaComum) => {
      return http.put(`/v1/parametros-reserva/${tenantId}/`, data);
    },
    { retry: false }
  );
}

export default useSaveParametrosAreaComum;
